import { render, staticRenderFns } from "./PatientDashboard.vue?vue&type=template&id=98581174&scoped=true&lang=pug"
import script from "./PatientDashboard.vue?vue&type=script&lang=js"
export * from "./PatientDashboard.vue?vue&type=script&lang=js"
import style0 from "./PatientDashboard.vue?vue&type=style&index=0&id=98581174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98581174",
  null
  
)

export default component.exports